import { makePresencePing } from './makePresencePing';
import { renewPresenceToken } from './renewPresenceToken';
import { getStorageJsonValue, SUPERSTORE_NAMESPACES, SUPERSTORE_STORAGE_ITEMS, SUPERSTORE_STORAGE_KEYS } from '../../../utils/superStoreUtils';
import { StopPingError } from './StopPingError';
const getPresenceToken = async () => {
  try {
    return await getStorageJsonValue({
      namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
      storageKey: SUPERSTORE_STORAGE_KEYS.BROWSER,
      storageItem: SUPERSTORE_STORAGE_ITEMS.PRESENCE_PING_TOKEN
    });
  } catch (e) {
    throw new StopPingError('failed to access local storage to read presence token');
  }
};
export const ping = async userId => {
  const presenceToken = await getPresenceToken();
  if (presenceToken) {
    await makePresencePing(presenceToken, userId);
  } else {
    await renewPresenceToken();
  }
};